/* import __COLOCATED_TEMPLATE__ from './user-became-idle.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import Component from '@glimmer/component';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type UserBecameIdle from 'embercom/objects/inbox/renderable/user-became-idle';
import { truncateEventText, isEventTextTruncated } from 'embercom/lib/inbox2/event-text-truncation';

interface UserBecameIdlePart extends RenderablePart {
  renderableData: UserBecameIdle;
}

interface Signature {
  Args: {
    part: UserBecameIdlePart;
  };
}

export default class Inbox2ConversationStreamEventPartsUserBecameIdleComponent extends Component<Signature> {
  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::UserBecameIdle': typeof Inbox2ConversationStreamEventPartsUserBecameIdleComponent;
    'inbox2/conversation-stream/event-parts/user-became-idle': typeof Inbox2ConversationStreamEventPartsUserBecameIdleComponent;
  }
}
